module.exports = __webpack_public_path__ + "ff59d93d59b52c1e2615011e99c3210f.pdf";